import { Component, Input, ViewChild, HostListener, EventEmitter, Output } from '@angular/core';
import { DwUtils } from 'src/app/components/utils/dw-utils';
import { Case } from 'src/app/models/case';
import { ServiceRequest } from 'src/app/models/service.request';
import { ValidationResult } from 'src/app/models/validation-result';
import { ServiceRequestsService } from 'src/app/services/service-requests.service';
import { Settings } from 'src/app/services/settings';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { HouseholdMember } from 'src/app/models/household-member';
import {
	ConfirmDialogComponent,
	ConfirmDialogModel
} from '../../../components/shared/confirmation-dialog/confirmation-dialog.component';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { AddeditmemberComponent } from './dialogs/addeditmember/addeditmember.component';
import { RequestSummary } from "../../../models/request-summary";
import { ServiceDef } from "../../../models/service-def";
import { TransactionHistoryService } from "../../../services/transactionhistory.service";
import { CasesService } from 'src/app/services/cases.service';
import { ServiceRequestMembersMap } from 'src/app/models/service-request-members-map';
import { ServiceRequestMemberHistory } from 'src/app/models/service-request-member-history';

@Component({
	selector: 'app-members',
	templateUrl: './members.component.html',
	styleUrls: ['./members.component.css']
})
export class MembersComponent {

	public strErr: string | null = '';
	@ViewChild(MatSort, { static: true }) sort: MatSort;

	displayWarningMessage = false;

	//public hasAdmin: boolean = false;
	public isEditing = false;
	public requestDate: any;
	public requestType: any;
	public source: any;
	public statusDesc: any;
	public agencyName: any;
	public amountRequested: any;
	public status: any;
	public statusColor = '';
	public result: boolean | null = false;
	public contentClassName: string | null = 'dwtable-container-bottom-without-save-strip';
	public selectedRecord: HouseholdMember;

	public _caseId = 0;
	public _serviceRequest: ServiceRequest;
	public caseRecord: Case;

	public Idx: number | null = -1;
	public records: HouseholdMember[];
	public historyMemberRecords: HouseholdMember[];
	public dataSource: MatTableDataSource<HouseholdMember>;
	public renderedData: Array<any>;
	public displayedColumns: string[];
	public displayedColumnsHistory: string[];
	public busyCursor: boolean = false;
	public visibleAddEditMemberDialog = false;
	public primaryAgencyFlag: boolean;
	//public readOnlyFlag=true;
	public showMembers = false;
	public showAdd = false;
	public showEdit = false;
	public showDelete = false;
	public editDOB = false;
	public viewDOB = false;
	public editComment= false;
	public viewComment= false;
	public editPrimaryApplicant= false;
	fromSource:string;
	strWarningMessage = '';
	requestemebrsMappins: ServiceRequestMembersMap[];
	/** true when displaying a closed request (read-only history view)
	 *  or a clerically reopened request (editable history view) **/
	public isHistoryMode = false;
	public historySourceRecords: ServiceRequestMemberHistory[] = [];
	@Input() set from(value: string) {
		this.fromSource = value;

	}
	@ViewChild('addeditmember', { static: true }) addeditmember: AddeditmemberComponent;
	strAddEditHeader = '';

	@Output() membersChanged = new EventEmitter();


	constructor(private serviceRequestsService: ServiceRequestsService, private casesService: CasesService,
		public txService: TransactionHistoryService, public dialog: MatDialog) {

	}

	public ngOnInit() {
		//this.hasAdmin = Settings.getInstance().hasPrivilege('ADMIN');

	}
	setSecurityPrivileges(){
		if(this.fromSource==='cases'){
			this.showMembers  = Settings.getInstance().hasPrivilege('CLIENTS_CASE_DETAILS_MEMBERS', "SHOW");
			this.showEdit  = Settings.getInstance().hasPrivilege('CLIENTS_CASE_DETAILS_MEMBERS_EDIT', "EXECUTE");	
			this.showDelete  = Settings.getInstance().hasPrivilege('CLIENTS_CASE_DETAILS_MEMBERS_DELETE', "EXECUTE");
			this.showAdd  = Settings.getInstance().hasPrivilege('CLIENTS_CASE_DETAILS_MEMBERS_ADD', "EXECUTE");
			
			this.editDOB  = Settings.getInstance().hasPrivilege('CLIENTS_CASE_DETAILS_MEMBERS_DOB', "WRITE");
			this.viewDOB  = Settings.getInstance().hasPrivilege('CLIENTS_CASE_DETAILS_MEMBERS_DOB', "SHOW");
			this.editComment  = Settings.getInstance().hasPrivilege('CLIENTS_CASE_DETAILS_MEMBERS_COMMENTS', "WRITE");
			this.viewComment  = Settings.getInstance().hasPrivilege('CLIENTS_CASE_DETAILS_MEMBERS_COMMENTS', "SHOW");
			this.editPrimaryApplicant  = Settings.getInstance().hasPrivilege('CLIENTS_CASE_DETAILS_MEMBERS_EDIT_APPLICANT', "EXECUTE");
		} else{
			this.showMembers  = Settings.getInstance().hasPrivilege('REQUEST_DETAIL_MEMBERS', "SHOW");
			this.showEdit  = Settings.getInstance().hasPrivilege('REQUEST_DETAIL_MEMBERS_EDIT', "EXECUTE");	
			this.showDelete  = Settings.getInstance().hasPrivilege('REQUEST_DETAIL_MEMBERS_DELETE', "EXECUTE");
			this.showAdd  = Settings.getInstance().hasPrivilege('REQUEST_DETAIL_MEMBERS_ADD', "EXECUTE");
			
			this.editDOB  = Settings.getInstance().hasPrivilege('REQUEST_DETAIL_MEMBERS_DOB', "WRITE");
			this.viewDOB  = Settings.getInstance().hasPrivilege('REQUEST_DETAIL_MEMBERS_DOB', "SHOW");
			this.editComment  = Settings.getInstance().hasPrivilege('REQUEST_DETAIL_MEMBERS_COMMENTS', "WRITE");
			this.viewComment  = Settings.getInstance().hasPrivilege('REQUEST_DETAIL_MEMBERS_COMMENTS', "SHOW");
			this.editPrimaryApplicant  = Settings.getInstance().hasPrivilege('REQUEST_DETAIL_MEMBERS_EDIT_APPLICANT', "EXECUTE");
		}
		if (this.showAdd) {
			this.editDOB = true;
			this.editComment = true;
		}
		if (this.viewDOB) {
			this.displayedColumns = ['memberComments', 'id', 'firstName', 'middleName', 'lastName', 'dateOfBirth', 'gender', 'relationship', 'edit', 'delete'];
		} else {
			this.displayedColumns = ['memberComments', 'id', 'firstName', 'middleName', 'lastName', 'gender', 'relationship', 'edit', 'delete'];
		}

		// History table: same comment icon column as live; no edit/delete
		this.displayedColumnsHistory = this.viewDOB
			? ['memberComments', 'id', 'memberId', 'firstName', 'middleName', 'lastName', 'dateOfBirth', 'gender', 'relationship']
			: ['memberComments', 'id', 'memberId', 'firstName', 'middleName', 'lastName', 'gender', 'relationship'];

	}
	public onShowHandler(caseId: number, serviceRequest) {
		if (caseId === undefined || caseId === null || isNaN(caseId as any) || caseId < 1) {
			this._caseId = 0;
			return;
		}
		this._caseId = caseId;
		this._serviceRequest = serviceRequest || new ServiceRequest();
		this.setSecurityPrivileges();
		this.primaryAgencyFlag = Settings.getInstance().isPrimaryAgency(this._serviceRequest.agencyId);

		/** History mode applies only to the Requests workspace, where _serviceRequest is a real
		 *  ServiceRequest. In the Cases workspace the record passed in is the Case itself, so its id
		 *  must never be used as a service_request_id for history lookups. **/
		const isRequestContext = this.fromSource === 'requests';
		this.isHistoryMode = isRequestContext &&
			(this._serviceRequest.recordStatus === 0 || this._serviceRequest.clericalOpen === 1);

		if (this._caseId < 1) {
			return;
		}

		this.isEditing = false;
		this.busyCursor = true;

		this.serviceRequestsService.getCaseById(this._caseId).subscribe(
			(result1) => {
				this.caseRecord = new Case();
				Object.assign(this.caseRecord, result1);
				//this.displayDetails();
				this.loadMembers();
				this.busyCursor = false;
			},
			(error1) => {
				Settings.getInstance().handleError('Error: unable to retrieve case details from the server');
				this.busyCursor = false;
			}
		);
	}
	public loadRequestMemberMappings() {
		const memberIds = this.records.map(r => r.memberId);

		this.casesService.getServiceRequestMemberMappingsByMemberIds(memberIds).subscribe(
			(mapped: any[]) => {
				this.requestemebrsMappins = mapped;

				for (let rec of this.records) {
					const mappingsForMember = mapped.filter(m => m.map_member_id === rec.memberId);
					// initialize counters
					const closedCount = mappingsForMember.filter(m => m.requestrecordstatus === 0).length;
					const openCount = mappingsForMember.filter(m => m.requestrecordstatus === 1).length;

					rec['noOfClosedRequests'] = closedCount;
					rec['noOfOpenRequests'] = openCount;
					if (mappingsForMember.length === 0) {

						rec.deletable = true;
						rec.editable = true;
						continue;
					}

					const hasClosed = mappingsForMember.some(m => m.requestrecordstatus === 0); // 0 = closed
					
					/** In Cases workspace: allow editing if case is open, regardless of closed requests
					 *  In Requests workspace: prevent editing if member belongs to a closed request **/
					if (this.fromSource === 'cases') {
						// Cases workspace: editable if case is open
						if (this.caseRecord?.caseStatus === 'Open') {
							rec.deletable = false; // can't delete if member is in any request
							rec.editable = true;
							rec['warning'] = hasClosed 
								? "This member belongs to closed requests. Changes will only affect future requests."
								: "The member changes will impact existing requests. Please notify agencies of the change.";
						} else {
							rec.deletable = false;
							rec.editable = false;
							rec['warning'] = "Case is closed. Cannot edit members.";
						}
					} else {
						// Requests workspace: use original logic
						if (hasClosed) {
							// not allowed
							rec.deletable = false;
							rec.editable = false;
							rec['warning'] = "A closed request includes this member. Contact the Help Desk.";
						} else {
							// allowed with warning
							rec.deletable = false;
							rec.editable = true;
							rec['warning'] = "The member changes will impact existing requests. Please notify agencies of the change.";
						}
					}
				}
			},
			() => {
				Settings.getInstance().handleError(
					'Error: unable to retrieve member mappings from the server'
				);
			}
		);
	}

	public loadMembers() {
		if (this.isHistoryMode) {
			this.loadHistoryMembers();
		} else {
			this.loadLiveMembers();
		}
	}

	/** Load members from the live HouseholdMembers table (open requests) **/
	public loadLiveMembers() {
		this.busyCursor = true;
		this.serviceRequestsService.getHouseholdMembersByCaseId(this._caseId).subscribe(
			(result2) => {
				this.records = result2;
				this.historyMemberRecords = [];
				Object.assign(this.historyMemberRecords, result2);
				for (const rec of this.records) {
					if (rec.memberComments !== null) {
						if (rec.memberComments.length === 0) {
							rec.memberComments = null;
						}
					}
					if (rec.dateOfBirth !== null) {
						try {
							rec['dob'] = rec.dateOfBirth.split('T')[0];
						} catch (Exception) {
							rec.dateOfBirth = null;
						}
					}
				}
				this.dataSource = new MatTableDataSource(this.records);
				this.dataSource.sort = this.sort;
				this.busyCursor = false;
				this.loadRequestMemberMappings();
			},
			(error1) => {
				Settings.getInstance().handleError('Error: unable to retrieve family details from the server');
				this.busyCursor = false;
			}
		);
	}

	/** Load members from ServiceRequestMemberHistory table (closed / clerically reopened requests) **/
	public loadHistoryMembers() {
		if (!this._serviceRequest || this._serviceRequest.id < 1) {
			return;
		}
		this.busyCursor = true;
		this.casesService.getMemberHistory(this._serviceRequest.id).subscribe(
			(result: ServiceRequestMemberHistory[]) => {
				this.historySourceRecords = result;
				const householdHistory = result.filter(h => !ServiceRequestMemberHistory.isContactOnlyAdvocate(h));
				/** Map history records onto HouseholdMember shape so the existing table renders them **/
				this.records = householdHistory.map(h => {
					const m = new HouseholdMember();
					m['historyId'] = h.id;
					m['historySelected'] = h.selected;
					m.memberId = h.memberId;
					m.id = h.id;   // history table PK
					m.firstName = h.firstName;
					m.middleName = h.middleName;
					m.lastName = h.lastName;
					m.dateOfBirth = h.dateOfBirth;
					m['dob'] = h.dateOfBirth ? h.dateOfBirth.split('T')[0] : null;
					m.gender = h.gender;
					m['relationship'] = h.relationship;
					m['address'] = h.address || '';
					m.memberComments = h.memberComments ?? null;
				/** Disable editing/deleting in history mode (both closed and clerical reopen) **/
				m.editable = false;
				m.deletable = false;
					return m;
				}) as any[];
				this.dataSource = new MatTableDataSource(this.records);
				this.dataSource.sort = this.sort;
				this.busyCursor = false;
			},
			() => {
				Settings.getInstance().handleError('Error: unable to retrieve member history from the server');
				this.busyCursor = false;
			}
		);
	}
	public addNewClickHandler() {
		this.strAddEditHeader = 'Add a new member';
		this.visibleAddEditMemberDialog = true;
		const caseAddr = [this.caseRecord?.address1, this.caseRecord?.city, this.caseRecord?.state, this.caseRecord?.zipCode].filter(x => x).join(', ');
		this.addeditmember.onShowHandler(true, this._caseId, null, true, true, this.editComment, this.viewComment, this.editPrimaryApplicant, this.records, this.isHistoryMode, this._serviceRequest?.id, caseAddr);
	}
	public editMemberHandler(member: any) {
		this.strAddEditHeader = 'Edit Family Member';
		this.visibleAddEditMemberDialog = true;
		this.addeditmember.onShowHandler(false, this._caseId, member, this.editDOB, this.viewDOB, this.editComment, this.viewComment, this.editPrimaryApplicant, this.records, this.isHistoryMode, this._serviceRequest?.id, member['address'] || '');
	}
	public deleteHistoryMemberHandler(element: any) {
		const message = 'Remove "' + element.firstName + ' ' + element.lastName + '" from this request history - Are you sure?';
		const dialogData = new ConfirmDialogModel('Please Confirm', message);
		const dialogRef = this.dialog.open(ConfirmDialogComponent, {
			width: '400px',
			data: dialogData,
			panelClass: 'custom-dialog-container'
		});
		dialogRef.afterClosed().subscribe(dialogResult => {
			if (dialogResult === true) {
				this.casesService.deleteMemberFromHistory(element.id).subscribe(
					() => this.loadHistoryMembers(),
					(error) => Settings.getInstance().handleError(error, 'deleting history member')
				);
			}
		});
	}
	public validateFields(record: Case): boolean {

		this.strErr = '';
		const vr: ValidationResult = record.validateRecord();

		if (vr.error.length > 0) {
			this.strErr = vr.error;
			DwUtils.setFocus(vr.focus_field);
			return false;
		}
		return true;
	}
	public cancelSubmitRecord() {
		this.isEditing = false;
		this.records = [];
		Object.assign(this.records, this.historyMemberRecords);
		this.dataSource = new MatTableDataSource(this.records);
	}
	public unlinkMember(element: any) {

		const message = 'Unlink Member: "' + element.firstName + ' ' + element.lastName + ' from this case" - Are you' +
			' sure?';
		const dialogData = new ConfirmDialogModel('Please Confirm', message);

		const dialogRef = this.dialog.open(ConfirmDialogComponent, {
			width: '400px',
			data: dialogData,
			panelClass: 'custom-dialog-container'
		});

		dialogRef.afterClosed().subscribe(dialogResult => {
			this.result = dialogResult;
			if (this.result === true) {
				this.serviceRequestsService.unlinkHouseholdMember(element.id).subscribe(
					(data) => {

						this.txService.createTransactionHistory('Cases', element.caseId, 'Remove',
							'Removed member: ' + element.firstName + ' ' + element.lastName);
						this.loadMembers();
						this.membersChanged.emit();
					},
					(error) => {
						Settings.getInstance().handleError(error);
					});
			}
		});
	}
	public submitAddEditWindowHandler() {
		this.visibleAddEditMemberDialog = false;
		this.loadMembers();
		if (!this.isHistoryMode) {
			/** Only show live-member warning for open requests **/
			if (this.strAddEditHeader === 'Add a new member') {
				this.strWarningMessage = 'The member changes will impact existing requests.  Please notify agencies of the change in case the new member needs to be added to an existing request';
				this.displayWarningMessage = true;
			} else {
				if (this.selectedRecord && this.selectedRecord['noOfOpenRequests'] > 0) {
					this.strWarningMessage = 'The member changes will impact existing requests.  Please notify agencies of the change';
					this.displayWarningMessage = true;
				}
			}
		}
		this.membersChanged.emit();
	}
	public onRowClicked(row: any): void {
		this.selectedRecord = row;
		this.selectRow();

	}
	public onRowDblClicked(): void {

		if (this.showEdit === true && this.selectedRecord.editable) {
			this.editMemberHandler(this.selectedRecord);
		}
	}
	public tableKeyDown(event: KeyboardEvent) {

		const len: number = this.dataSource.filteredData.length;
		if (event.key === 'ArrowDown') {
			if (this.Idx < (len - 1)) {
				this.selectedRecord = this.dataSource.filteredData[++this.Idx];

			}
		} else if (event.key === 'ArrowUp') {
			if (this.Idx > 0) {
				this.selectedRecord = this.dataSource.filteredData[--this.Idx];

			}
		} else if (event.key === 'Enter') {
			if ((this.Idx >= 0) && (this.selectedRecord !== undefined)) {
				this.editMemberHandler(this.selectedRecord);
			}
		}
	}
	public selectRow() {
		if (this.selectedRecord.id === 0) {
			this.unSelectRow();
			return;
		}
		this.Idx = this.dataSource.filteredData.findIndex(s => s.id === this.selectedRecord.id);
	}
	public unSelectRow() {
		this.Idx = -1;
		this.selectedRecord = new HouseholdMember();
	}
}
